import React, { useEffect, createElement } from 'react';
import { CountdownTimer } from './components/CountdownTimer';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludesSection } from './components/IncludesSection';
import { ResultsSection } from './components/ResultsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { HowToReceiveSection } from './components/HowToReceiveSection';
import { UpsellSection } from './components/UpsellSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
// Meta Pixel Helper
const initPixel = () => {
  try {
    // @ts-ignore
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // @ts-ignore
    if (window.fbq) {
      // @ts-ignore
      window.fbq('init', '836421405954360');
      // @ts-ignore
      window.fbq('track', 'PageView');
    }
  } catch (e) {
    console.warn('Meta Pixel failed to initialize:', e);
  }
};
export function App() {
  useEffect(() => {
    initPixel();
    // Track AddToCart on all purchase buttons
    const handlePurchaseClick = () => {
      // @ts-ignore
      if (window.fbq) window.fbq('track', 'AddToCart');
    };
    const buttons = document.querySelectorAll('a[href*="myshopify.com"]');
    buttons.forEach(btn => btn.addEventListener('click', handlePurchaseClick));
    return () => {
      buttons.forEach(btn => btn.removeEventListener('click', handlePurchaseClick));
    };
  }, []);
  return <div className="min-h-screen font-sans text-gray-900 bg-white" data-id="element-0">
      <CountdownTimer data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPointsSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <IncludesSection data-id="element-6" />
        <ResultsSection data-id="element-7" />
        <BonusSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <HowToReceiveSection data-id="element-10" />
        <UpsellSection data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FAQSection data-id="element-14" />
        <FinalCTASection data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
      <SocialProofPopup data-id="element-17" />
    </div>;
}